$(function () {
    if ($('#FeeSubsidyApprovalForm').length > 0) {


        function UpdateFilters(date) {
            if (date === undefined) {
                date = $("#CurrentSubmissionPeriod").val();
                console.log(date);
            }

            var filterWarning = $("input[type='radio'][name='FilterByWarning']:checked").val();
            var filterStatus = $("input[type='radio'][name='FilterByStatus']:checked").val();
            var searchText = $("input#SearchText").val();

            window.location.href =
                jsPeriodLink + "?submissionPeriod=" + date + "&" +
                "filterWarning=" + filterWarning + "&" +
                "filterStatus=" + filterStatus + "&" +
                "searchString=" + searchText
        }

        $('#SubmissionPeriod').datetimepicker('options', {
            format: "YYYY-MM-DD",
            locale: jsLang + "-ca",
            keepOpen: false,
            defaultDate: false
        });


        $('#SubmissionPeriod').keydown(function (e) {
            e.preventDefault();
        });

        $('#SubmissionPeriod').on('change.datetimepicker', function (e) {
            var date = moment(e.date).format('YYYY-MM-DD');
            var currentDate = $("#CurrentSubmissionPeriod").val();

            if (date != currentDate) {
                UpdateFilters(date);
            }
        });

        $("input[type='radio'][name='FilterByStatus']").on('click', function () {
            UpdateFilters();
        });

        $("input[type='radio'][name='FilterByWarning']").on('click', function () {
            UpdateFilters();
        });

        $("button#SearchButton").on('click', function () {
            UpdateFilters();
        });

        $("input[type='text']#SearchText").on('keyup', function (e) {
            if (e.keyCode == 13) {
                $("button#SearchButton").click();
            }
        });

        function Load() {
            var viewStatus = $("input[type='radio'][name='FilterByStatus']:checked").val();
            var viewWarning = $("input[type='radio'][name='FilterByWarning']:checked").val();

            var resultsCountStr = jsOperatorsLabel + " (" + jsOperCount + "); " + jsLicensesLabel + " (" + jsLicenseCount + ")";
            $("#ResultsCount").text(resultsCountStr);

            // Remove/show verify all/submit buttons as appropriate
            if (jsOperCount > 0 && viewWarning == jsViewNoWarning && viewStatus == jsViewReadyStatus) {
                $("div#VerifyAllDiv").removeClass("d-none");
            } else {
                $("div#VerifyAllDiv").addClass("d-none");
            }

            if (jsOperCount > 0 && viewStatus == jsViewReadyStatus) {
                $(".submit-button").removeClass("d-none");
            } else {
                $(".submit-button").addClass("d-none");
            }
        }

        Load();

        // Verified checkbox is set on a per-operator basis.
        $("input.verified").click(function () {
            // If we change any of the verified boxes, we need to reset the 'select all' check at the bottom.
            $("input#chkCheckAll").prop("checked", false);

            SetVerified($(this));
        });

        function SetVerified(chk) {
            var isVerified = chk.is(":checked");
            var card = chk.parents(".card").first();
            var header = card.children(".card-header").first();

            // If verified is checked, we need to uncheck and disable all the denied checkboxes.
            card.find("input.denied").each(function () {
                $(this).prop("disabled", isVerified);
                if (isVerified) {
                    if ($(this).is(":checked")) {
                        $(this).parents(".row").find(".denied-detail").each(function () {
                            $(this).addClass("d-none");
                        });
                    }

                    $(this).prop("checked", false);
                }
            });

            // If verified is checked, we need to check and enable all the operational grant checkboxes.
            // If it's unchecked we need to disable and uncheck them.
            card.find("input.grant").each(function () {
                $(this).prop("disabled", !isVerified);
                $(this).prop("checked", isVerified);
                if (!isVerified) {
                    $(this).parents(".row").find(".grant-detail").each(function () {
                        $(this).addClass("d-none");
                    });
                }
            });

            if (isVerified) {
                card.removeClass("border-danger");
                card.addClass("border-success");

                header.removeClass("bg-danger");
                header.addClass("bg-success");
                header.addClass("text-white");
            } else {
                card.removeClass("border-success");

                header.removeClass("bg-success");
                header.removeClass("text-white");
            }
        }

        // Denied checkbox is set on a per-license basis.
        $("input.denied").click(function () {

            var isCurrentDenied = $(this).is(":checked");
            var detail = $(this).parents(".row").find(".denied-detail").first();

            $(this).parent("span.denied-reason-error").addClass("d-none");

            if (isCurrentDenied) {
                detail.removeClass("d-none");
            } else {
                detail.addClass("d-none");
            }

            var card = $(this).parents(".card").first();
            var header = card.children(".card-header").first();

            var isDenied = false;

            // Check if ANY of the licenses are denied.
            // If so, we keep the error border. Otherwise we remove it.
            card.find("input.denied").each(function () {
                if ($(this).is(":checked")) {
                    isDenied = true;
                    return false;
                }
            });

            if (isDenied) {
                card.removeClass("border-sucees");
                card.addClass("border-danger");

                card.find("input.verified").prop("disabled", true);

                header.removeClass("bg-sucess");
                header.addClass("bg-danger");
                header.addClass("text-white");
            } else {
                card.removeClass("border-danger");

                card.find("input.verified").prop("disabled", false);

                header.removeClass("bg-danger");
                header.removeClass("text-white");
            }
        });

        $("select.denied-reason").change(function () {
            $(this).siblings(".denied-reason-error").first().addClass("d-none");
            if ($(this).val() == jsFeeSubsidyDenialTypeOther) {
                $(this).siblings(".denied-other-detail").first().removeClass("d-none");
            } else {
                $(this).siblings(".denied-other-detail").first().addClass("d-none");
            }
        });

        $("textarea.denied-other-text").keydown(function () {
            $(this).siblings(".denied-other-error").first().addClass("d-none");
        });

        $("input.grant").click(function () {
            var isCurrentApproved = $(this).is(":checked");
            var detail = $(this).parents(".row").find(".grant-detail").first();

            $(this).parent("span.grant-reason-error").addClass("d-none");

            if (isCurrentApproved) {
                detail.addClass("d-none");
            } else {
                detail.removeClass("d-none");
            }
        });

        $("select.grant-reason").change(function () {
            $(this).siblings(".grant-reason-error").first().addClass("d-none");
            if ($(this).val() == jsGrantDenialTypeOther) {
                $(this).siblings(".grant-other-detail").first().removeClass("d-none");
            } else {
                $(this).siblings(".grant-other-detail").first().addClass("d-none");
            }
        });

        $("textarea.grant-other-text").keydown(function () {
            $(this).siblings(".grant-other-error").first().addClass("d-none");
        });


        $("input#chkCheckAll").click(function () {
            if ($(this).is(":checked")) {
                $(".operator-card:not(d-none) input.verified:not(:checked)").each(function () {
                    $(this).prop("checked", true);
                    SetVerified($(this));
                });
            } else {
                $(".operator-card:not(d-none) input.verified:checked").each(function () {
                    $(this).prop("checked", false);
                    SetVerified($(this));
                });
            }
        });

        $(".submit-button").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($("input#chkCheckAll").is(":checked")) {
                $("#confirmModal").modal({
                    'backdrop': 'static'
                });

                return false;
            }

            return Submit();
        });

        $(".submit-button-modal").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            return Submit();
        });

        function Submit() {
            $(".error-message:not(.d-none)").addClass("d-none");
            $("span.denied-reason-error:not(.d-none)").addClass("d-none");
            $("span.denied-other-error:not(.d-none)").addClass("d-none");

            var hasErrors = false;

            // Gather the verified operators and denied licenses that match the filters to send back to the server.
            // This is the only data that should be posted.

            var verifiedList = []
            var deniedGrantList = [];

            $(".operator-card:not('.d-none') input.verified:checked").each(function () {
                verifiedList.push($(this).val());

                var deniedGrants = $(this).parents(".operator-card").first().find("input.grant:not(:checked)");
                deniedGrants.each(function () {
                    var deniedReason = $(this).parents(".row").first().find("select.grant-reason :selected").first().val();
                    var deniedOtherDetail = $(this).parents(".row").first().find("textarea.grant-other-text").first().val();
                    var deniedObject = {
                        FeeSubsidySubmissionId: $(this).val(),
                        DeniedReason: deniedReason,
                        DeniedOtherDetail: deniedOtherDetail
                    }
                    deniedGrantList.push(deniedObject);


                    if (deniedReason == "-1") {
                        hasErrors = true;
                        $(this).parents(".row").first().find(".grant-reason-error").first().removeClass("d-none");
                    } else if (deniedReason == jsFeeSubsidyDenialTypeOther) {
                        if ($(this).parents(".row").first().find("textarea.grant-other-text").first().val().trim() == "") {
                            hasErrors = true;
                            $(this).parents(".row").first().find(".grant-other-error").first().removeClass("d-none");
                        }
                    }
                });
            });

            var deniedList = [];
            $(".operator-card:not('.d-none') input.denied:checked").each(function () {
                var deniedReason = $(this).parents(".row").first().find("select.denied-reason :selected").first().val();
                var deniedOtherDetail = $(this).parents(".row").first().find("textarea.denied-other-text").first().val();
                var deniedObject = {
                    FeeSubsidySubmissionId: $(this).val(),
                    DeniedReason: deniedReason,
                    DeniedOtherDetail: deniedOtherDetail
                }
                deniedList.push(deniedObject);


                if (deniedReason == "-1") {
                    hasErrors = true;
                    $(this).parents(".row").first().find(".denied-reason-error").first().removeClass("d-none");
                } else if (deniedReason == jsFeeSubsidyDenialTypeOther) {
                    if ($(this).parents(".row").first().find("textarea.denied-other-text").first().val().trim() == "") {
                        hasErrors = true;
                        $(this).parents(".row").first().find(".denied-other-error").first().removeClass("d-none");
                    }
                }
            });

            if (verifiedList.length == 0 && deniedList.length == 0) {
                hasErrors = true;
                $(".error-message").text(jsErrorNoSelection);
                $(".error-message").removeClass("d-none");
            }

            if (!hasErrors) {
                $("#VerifiedOperators").val(JSON.stringify(verifiedList));
                $("#DeniedGrants").val(JSON.stringify(deniedGrantList));
                $("#DeniedLicenses").val(JSON.stringify(deniedList));

                $("#FilterWarning").val($("input[type='radio'][name='FilterByWarning']:checked").val());
                $("#FilterStatus").val($("input[type='radio'][name='FilterByStatus']:checked").val());

                $('#FeeSubsidyApprovalForm').submit();
            }

            return false;
        }

        $(".reopen-button").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $("#ReopenOperatorId").val($(this).val());

            $("#reopenModal").modal({
                'backdrop': 'static'
            });

            return false;
        });

        $(".reopen-button-modal").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $('#FeeSubsidyApprovalForm').submit();
            return false;
        });

    } // if ($('#FeeSubsidyApprovalForm').length > 0) 
}); // $(function () {